import React, { PropsWithChildren } from "react";

import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Collapse from "@mui/material/Collapse";

import Skeleton from "../Skeleton/Skeleton";
import Text from "../Typography/Text";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./ItemWithExpandCollapseContent.module.css";

interface Props {
  label: string;
  expand: boolean;
  setExpand: (bool: boolean) => void;
}

const ItemWithExpandCollapseContent: React.FC<PropsWithChildren<Props>> = (
  props
) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.itemHeader}
        onClick={() => props.setExpand(!props.expand)}
      >
        <Text variant="body" color={"text"}>
          {props.label}
        </Text>

        <ArrowRightIcon
          className={toClassName(
            styles.arrow,
            props.expand ? styles.arrowRotateDown : styles.arrowRotateRight
          )}
        />
      </div>

      <Collapse orientation="vertical" in={props.expand} collapsedSize={0}>
        {props.children}
      </Collapse>
    </div>
  );
};

const LoadingItemWithExpandCollapseContent: React.FC<
  React.PropsWithChildren<object>
> = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.itemHeader}>
        <Skeleton width={50} />

        <ArrowRightIcon
          className={toClassName(styles.arrow, styles.arrowRotateRight)}
        />
      </div>
      {children}
    </div>
  );
};

export { LoadingItemWithExpandCollapseContent };

export default ItemWithExpandCollapseContent;
